// Тип точки «Укриття»: такие точки рисуются пином как в Google Maps, а не кружком с номером —
// так укрытие сразу отличается от обычных объектов комплекса
export const SHELTER_POINT_TYPE = "shelter";

// Размер пина укрытия. Высота больше ширины — форма «капли»; 30×40 визуально сопоставимо
// с кружком номера (28px + рамка), чтобы пин не терялся и не перекрывал соседние точки
export const SHELTER_PIN_WIDTH_PX = 30;
export const SHELTER_PIN_HEIGHT_PX = 40;
